import { render, staticRenderFns } from "./VstContragentEditPage.vue?vue&type=template&id=95938676"
import script from "./VstContragentEditPage.vue?vue&type=script&lang=js"
export * from "./VstContragentEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports